import { ExtendedRelatedPerson } from '@seen/core/models/relatedPerson'
import type { JSX } from 'react'
import { OrganizationNameplate } from '#src/components/nameplates/OrganizationNameplate.tsx'
import { ParticipantNameplate } from '#src/components/nameplates/ParticipantNameplate.tsx'
import { PractitionerNameplate } from '#src/components/nameplates/PractitionerNameplate.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ReferenceNameplate({
  resourceType,
  reference,
}: {
  resourceType: string
  reference: string
}): JSX.Element {
  if (resourceType === 'Patient') {
    return <ParticipantNameplate participant={reference} />
  }
  if (resourceType === 'Practitioner') {
    return <PractitionerNameplate practitioner={reference} />
  }
  if (resourceType === 'Organization') {
    return <OrganizationNameplate organization={reference} />
  }
  return <RelatedPersonLabel reference={reference} />
}

function RelatedPersonLabel({ reference }: { reference: string }): JSX.Element {
  const { data } = useRead(ExtendedRelatedPerson, reference)
  return <span>{data?.name ?? 'Contact'}</span>
}
